import { render, staticRenderFns } from "./px-level.vue?vue&type=template&id=0933b4cd&scoped=true&"
import script from "./px-level.vue?vue&type=script&lang=ts&"
export * from "./px-level.vue?vue&type=script&lang=ts&"
import style0 from "./px-level.vue?vue&type=style&index=0&id=0933b4cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0933b4cd",
  null
  
)

export default component.exports